function colKey(col) {
  if (!col) return null
  return col.accessorKey ?? col.accessorkey ?? null
}

/** Names of personnel-specific allowances (user_id set on allowance row). */
export function getPersonnelAllowanceNames(payroll) {
  const allowanceRows = payroll?.allowances || []
  return allowanceRows
    .filter((a) => a?.user_id != null)
    .map((a) => a?.name)
    .filter(Boolean)
}

/**
 * Granular allowance keys for payslip visibility (personnel by name + store/group columns).
 * Does not include the consolidated "Personnel allowances" table column key.
 */
export function getAllowanceColumnKeysFromPayroll(payroll) {
  const allowanceRows = payroll?.allowances || []
  const personnelNames = allowanceRows
    .filter((a) => a?.user_id != null)
    .map((a) => a?.name)
    .filter(Boolean)
  const storeGroupNames = allowanceRows
    .filter((a) => a != null && !a.user_id)
    .map((a) => a?.name)
    .filter(Boolean)
  return Array.from(new Set([...personnelNames, ...storeGroupNames]))
}

/**
 * Picker menu = payroll table columns (excluding consolidated Personnel allowances — added in PayrollTable when granular personnel are on) + synthetic rows per personnel allowance name.
 */
export function getPayrollPickerColumnTemplates(payrollColumns = [], payroll = null) {
  const allowanceRows = payroll?.allowances || []
  const personnelNames = allowanceRows
    .filter((a) => a?.user_id != null)
    .map((a) => a?.name)
    .filter(Boolean)
  const cols = (payrollColumns || []).filter((c) => colKey(c) !== 'Personnel allowances')
  const payrollKeys = new Set(cols.map((c) => colKey(c)).filter(Boolean))
  const synthetic = personnelNames
    .filter((name) => name && !payrollKeys.has(name))
    .map((name) => ({
      accessorKey: name,
      header: name,
      payslipOnly: true,
    }))
  return [...cols, ...synthetic]
}
